export default {
  year: '年',
  month: '月',
  day: '日',
  hour: '时',
  minute: '分'
};